import { getAuthAxiosInstance as authAxios } from './axios';
import { REACT_APP_BACKEND_URL } from '../utils/constants';

const getAxios = () => {
  const instance = authAxios();
  if (!instance) throw new Error('Not authenticated');
  return instance;
};

export const pollNotifications = async (cursor?: string, cursorId?: string, limit?: number) => {
  const params = new URLSearchParams();
  if (cursor) params.set('cursor', cursor);
  if (cursorId) params.set('cursorId', cursorId);
  if (limit) params.set('limit', String(limit));
  const query = params.toString();
  return getAxios().get(`${REACT_APP_BACKEND_URL}/notification${query ? `?${query}` : ''}`);
};

export const markSeen = async (notificationIds: string[]) => {
  return getAxios().patch(`${REACT_APP_BACKEND_URL}/notification/seen`, {
    notificationIds,
  });
};

export const dismissNotification = async (id: string) => {
  return getAxios().delete(`${REACT_APP_BACKEND_URL}/notification/${id}`);
};

export const dismissAll = async () => {
  return getAxios().delete(`${REACT_APP_BACKEND_URL}/notification/all`);
};

export const getNotificationPreferences = async () => {
  return getAxios().get(`${REACT_APP_BACKEND_URL}/notification/preferences`);
};

export const updateNotificationPreferences = async (prefs: {
  enableSignatureNeeded?: boolean;
  enableTransactionCompleted?: boolean;
  enableWalletConfigUpdated?: boolean;
  enableWalletInvitation?: boolean;
}) => {
  return getAxios().patch(`${REACT_APP_BACKEND_URL}/notification/preferences`, prefs);
};
